module.exports = __webpack_public_path__ + "img/btn_menu_hgt_c.e75ff8b3.png";